import React from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import ArtPieceSharedDetails from "./SharedDetails"

const ArtPieceSculpture = () => {
  return (
    <div className="container">
      <ArtPieceSharedDetails />
      <div className="row">
        <div className="col-4">
          <FormInput
            name="sculpture.width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width"
          />
        </div>
        <div className="col-4">
          <FormInput
            name="sculpture.height"
            label="Height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
        <div className="col-4">
          <FormInput
            name="sculpture.length"
            label="Length"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPieceSculpture
